import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import { useSelector } from 'react-redux'

export default function Mainlayout(props) {
  
  const colo = useSelector((state) => state.theme)
  
  

  return (
    <>
      <div className={`${colo.theme}`}>
        <Navbar />
        {props.children}
        <Footer />
      </div>
    </>
  )
}
